import { UploadComponent } from './../components/upload/upload';
import { BrowserModule } from '@angular/platform-browser';
import { ErrorHandler, NgModule } from '@angular/core';
import { IonicApp, IonicErrorHandler, IonicModule } from 'ionic-angular';
import { SplashScreen } from '@ionic-native/splash-screen';
import { StatusBar } from '@ionic-native/status-bar';

import { AngularFireModule } from 'angularfire2';
import { AngularFirestoreModule } from 'angularfire2/firestore';
import { AngularFireAuthModule } from 'angularfire2/auth';
import { AngularFireStorage } from 'angularfire2/storage';

import { MyApp } from './app.component';
import { HomePage } from '../pages/home/home';
import { LoginPage } from '../pages/login/login';
import { PopoverPage } from '../pages/popover/popover';
import { ProfileviewPage } from '../pages/profileview/profileview';
import { DownloadsComponent } from '../components/downloads/downloads';
import { UsersComponent } from './../components/users/users';
import { UserDetailsComponent } from './../components/user-details/user-details';
import { UserDetailsUserComponent } from './../components/user-details-user/user-details-user';
import { TasksComponent } from './../components/tasks/tasks';
import { TasksAdminComponent } from './../components/tasks-admin/tasks-admin';
import { TasksUserComponent } from './../components/tasks-user/tasks-user';
import { TaskDetailsComponent } from './../components/task-details/task-details';
import { SessionsComponent } from './../components/sessions/sessions';
import { SessionAddPage } from './../pages/session-add/session-add';
import { SessionDetailPage } from './../pages/session-detail/session-detail';
import { CalendarComponent } from '../components/calendar/calendar';
import { CalendarAdminComponent } from '../components/calendar-admin/calendar-admin';
import { CalendarModule } from 'angular-calendar';
import { UsersAdminComponent } from '../components/users-admin/users-admin';
import { UserAddPage } from '../pages/user-add/user-add';
import { UserUpdatePage } from '../pages/user-update/user-update';
import { SessionUpdatePage } from '../pages/session-update/session-update';
import { TaskUpdatePage } from '../pages/task-update/task-update';
import { TaskDetailPage } from '../pages/task-detail/task-detail';
import { UserAddAdminPage } from '../pages/user-add-admin/user-add-admin';
import { UserUpdateAdminPage } from '../pages/user-update-admin/user-update-admin';
import { IonicStorageModule } from '@ionic/storage';
import { IonRatingComponent } from '../components/ion-rating/ion-rating';
import { EmailProvider } from '../providers/email/email';
import { HttpClientModule } from '@angular/common/http';
import { TaskAddPage } from '../pages/task-add/task-add';
import { OwlDateTimeModule, OwlNativeDateTimeModule, OWL_DATE_TIME_FORMATS } from 'ng-pick-datetime';
import { OwlMomentDateTimeModule } from 'ng-pick-datetime-moment';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ForgotPasswordPage } from '../pages/forgot-password/forgot-password';
import { ChangePasswordPage } from '../pages/change-password/change-password';
import { CreateUsersComponent } from '../components/create-users/create-users';
import { DeleteUsersComponent } from '../components/delete-users/delete-users';
import { UpdateUsersComponent } from '../components/update-users/update-users';
import { BatchPage } from '../pages/batch/batch';
import { PrivacyPolicyPage } from '../pages/privacy-policy/privacy-policy';
import { TermsAndConditionsPage } from '../pages/terms-and-conditions/terms-and-conditions';
import { ComplaintsAndSuggestionsPage } from '../pages/complaints-and-suggestions/complaints-and-suggestions';
import { ComAndSuggListPage } from '../pages/com-and-sugg-list/com-and-sugg-list';
import { ComAndSuggDetailPage } from '../pages/com-and-sugg-detail/com-and-sugg-detail';
//Calculator Components
import { ConstsProvider } from '../providers/retirement-tools/consts/consts';
import { RetirementCalculatorPage } from '../pages/retirement-tools/retirement-calculator/retirement-calculator';
import { PerfilComponent } from './../components/retirement-tools/retirement-calculator/perfil/perfil';
import { IngresosComponent } from './../components/retirement-tools/retirement-calculator/ingresos/ingresos';
import { GastosComponent } from './../components/retirement-tools/retirement-calculator/gastos/gastos';
import { ObjetivoComponent } from './../components/retirement-tools/retirement-calculator/objetivo/objetivo';
import { ResumenComponent } from './../components/retirement-tools/retirement-calculator/resumen/resumen';
import { ChartsModule } from 'ng2-charts';
import { AdminProvider } from '../providers/admin/admin';
import { AddExpensePage } from '../pages/retirement-tools/retirement-calculator/add-expense/add-expense';
import { ImageCropperModule } from 'ngx-image-cropper';
import { CropImagePage } from '../pages/crop-image/crop-image';
import { KeyboardFixDirective } from '../directives/keyboard-fix/keyboard-fix';
import { FontsProvider } from '../providers/retirement-tools/fonts/fonts';
import { ToolsPage } from '../pages/tools/tools';
import { ExpenseCalculatorPage } from '../pages/retirement-tools/expense-calculator/expense-calculator';
import { ExpenseCalculatorComponent } from '../components/retirement-tools/expense-calculator/expense-calculator/expense-calculator';
import { IonTableComponent } from '../components/ion-table/ion-table';

export const firebaseConfig = {
  apiKey: "AIzaSyC00InB0B7_HDIkFkpSNBUnV4MvZHx57Z0",
  authDomain: "gepp-bdcd3.firebaseapp.com",
  databaseURL: "https://gepp-bdcd3.firebaseio.com",
  projectId: "gepp-bdcd3",
  storageBucket: "gepp-bdcd3.appspot.com",
  messagingSenderId: "183813903205",
  appId: "1:183813903205:web:6d9e54724dbf0ef5"
};

export const MY_MOMENT_FORMATS = {
  parseInput: 'L LT',
  fullPickerInput: 'L LT',
  datePickerInput: 'L',
  timePickerInput: 'LT',
  monthYearLabel: 'MMMM YYYY',
  dateA11yLabel: 'L',
  monthYearA11yLabel: 'MMMM YYYY',
};

@NgModule({
  declarations: [
    MyApp,
    HomePage,
    LoginPage,
    PopoverPage,
    ProfileviewPage,
    DownloadsComponent,
    CalendarComponent,
    UsersComponent,
    UserDetailsComponent,
    TasksComponent,
    TasksAdminComponent,
    TasksUserComponent,
    TaskDetailsComponent,
    UserDetailsUserComponent,
    SessionsComponent,
    SessionAddPage,
    UserAddPage,
    UserUpdatePage,
    SessionDetailPage,
    SessionUpdatePage,
    TaskUpdatePage,
    TaskDetailPage,
    CalendarAdminComponent,
    UsersAdminComponent,
    UserAddAdminPage,
    UserUpdateAdminPage,
    IonRatingComponent,
    TaskAddPage,
    ForgotPasswordPage,
    ChangePasswordPage,
    UploadComponent,
    RetirementCalculatorPage,
    PerfilComponent,
    IngresosComponent,
    GastosComponent,
    ObjetivoComponent,
    ResumenComponent,
    AddExpensePage,
    CropImagePage,
    KeyboardFixDirective,
    CreateUsersComponent,
    DeleteUsersComponent,
    UpdateUsersComponent,
    BatchPage,
    PrivacyPolicyPage,
    TermsAndConditionsPage,
    ComplaintsAndSuggestionsPage,
    ComAndSuggListPage,
    ComAndSuggDetailPage,
    //////////////
    ToolsPage,
    ExpenseCalculatorPage,
    ExpenseCalculatorComponent,
    IonTableComponent,
  ],
  imports: [
    BrowserModule,
    IonicModule.forRoot(MyApp),
    AngularFireModule.initializeApp(firebaseConfig),
    AngularFirestoreModule,
    AngularFireAuthModule,
    CalendarModule.forRoot(),
    IonicStorageModule.forRoot(),
    HttpClientModule,
    BrowserModule,
    OwlDateTimeModule,
    OwlNativeDateTimeModule,
    OwlMomentDateTimeModule,
    BrowserAnimationsModule,
    ChartsModule,
    ImageCropperModule
  ],
  bootstrap: [IonicApp],
  entryComponents: [
    MyApp,
    HomePage,
    LoginPage,
    PopoverPage,
    ProfileviewPage,
    SessionAddPage,
    UserAddPage,
    UserUpdatePage,
    SessionDetailPage,
    SessionUpdatePage,
    TaskUpdatePage,
    TaskDetailPage,
    UserAddAdminPage,
    UserUpdateAdminPage,
    TaskAddPage,
    ForgotPasswordPage,
    ChangePasswordPage,
    UploadComponent,
    RetirementCalculatorPage,
    AddExpensePage,
    CropImagePage,
    ToolsPage,
    ExpenseCalculatorPage,
    BatchPage,
    PrivacyPolicyPage,
    TermsAndConditionsPage,
    ComplaintsAndSuggestionsPage,
    ComAndSuggListPage,
    ComAndSuggDetailPage,
  ],
  providers: [
    StatusBar,
    SplashScreen,
    { provide: ErrorHandler, useClass: IonicErrorHandler },
    { provide: OWL_DATE_TIME_FORMATS, useValue: MY_MOMENT_FORMATS },
    EmailProvider,
    ConstsProvider,
    AdminProvider,
    FontsProvider,
    AngularFireStorage
  ]
})
export class AppModule { }



// WEBPACK FOOTER //
// ./src/app/app.module.ts